import React from 'react'
import { Tooltip, IconButton, Box } from '@mui/material'
import { Help as HelpIcon } from '@mui/icons-material'

interface ColumnHelpTooltipProps {
  explanation: string
  condensed?: boolean
}

export default function ColumnHelpTooltip({
  explanation,
  condensed = false,
}: ColumnHelpTooltipProps) {
  return (
    <Tooltip
      title={<Box sx={{ maxWidth: 300, p: 1 }}>{explanation}</Box>}
      placement="top"
      arrow
      enterDelay={300}
      leaveDelay={200}
    >
      <IconButton
        size="small"
        sx={{
          p: 0.25,
          ml: 0.5,
          color: 'text.secondary',
          '&:hover': {
            color: 'primary.main',
            backgroundColor: 'action.hover',
          },
        }}
      >
        <HelpIcon fontSize={condensed ? 'small' : 'small'} />
      </IconButton>
    </Tooltip>
  )
}
